import contracts from "./contracts";
import files from "./files";

export default {
    contracts,
    files,
};
